import React from "react";

const navigateTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({
      behavior: 'smooth',
    });
  }

export default navigateTo;